import React, { useEffect, useState } from 'react';
import { extensionCallMenuItemsSubject } from '../../index';
import { MenuTypesName } from '../../sdk.types';
import { ExtensionMenuLink } from '../extension-menu-item';
import { ErrorBoundary } from '../error-boundary';
export const CallMenuWrapper = () => {
    const [extensionMenus, setExtensionMenus] = useState(extensionCallMenuItemsSubject.value);
    useEffect(() => {
        const navigationSubscription = extensionCallMenuItemsSubject.subscribe(setExtensionMenus);
        return () => {
            navigationSubscription.unsubscribe();
        };
    }, []);
    if (!extensionMenus.length)
        return null;
    return (<>
      {extensionMenus.map((extensionMenuItem, index) => <ErrorBoundary key={`${extensionMenuItem.props.key}_${index}`} extensionName={extensionMenuItem.extensionName}>
          <ExtensionMenuLink keyProp={extensionMenuItem.props.key} extensionName={extensionMenuItem.extensionName} menuType={MenuTypesName.CALL_MENU} {...extensionMenuItem.props}/>
        </ErrorBoundary>)}
    </>);
};
